<template>
	<div ref="relevanceBus">
		<EditRelative ref="EditRelative" @update="updateData"></EditRelative>
		<SearchRelative ref="SearchRelative"
										@AddAccountChoose="AddAccountChoose"
										@BuildNewAccount="buildNewAccount"
										@AddRelative="AddRelative"></SearchRelative>
		<transition-group tag="div"
											class="enableList mt05x bdSub boxR-light cb tra ml05x_E pb05x mt05x_E fL_E"
											:class="{pr3x:account.acountList.length>0,pr1x:account.acountList.length==0}"
											v-on:leave="el=>{transitionAction(el,'hide-x');}"
											:duration="500">
			<button v-if="account.acountList.length>0"
							class="clearTag hover-f-error hover-effect-rotate tra-fast"
							:key="'clear'"
							@click="clear"
							type="button">
				<div class="icoSys w1x h1x bgSub fSub fs16x">
					<Icon name="no" />
				</div>
			</button>
			<TagBox v-for="(account,index) in account.acountList"
							:key="account.entityRelId"
							:styleType="'tag'"
							:val="account.name"
							:data="account"
							@Remove="onRemove(account.entityRelId,index)"></TagBox>
			<button :key="'add'"
							class="lh15 cMain"
							type="button"
							@click.stop="_showList">{{'+'+getLanguageStr('word1650','商家')}}</button>
		</transition-group>
 		<div class="w50pct mt05x bdSub boxR-light pl05x pr05x"
				 v-show="showAccount" @mouseenter="showAccountMousePos=true"  @mouseleave="showAccountMousePos=false" v-clickoutside="handleClose">
			<ul class="bdLight-bottom_E chooseList">
				<!-- <li><a class="dpB" @click.stop="existAccount">{{getLanguageStr('word1683','选择已添加商家')}}</a></li> -->
				<li><a class="dpB" @click.stop="addAccount(1)">{{getLanguageStr('cmd174','添加已有商家')}}</a></li>
				<li><a class="dpB" @click.stop="buildNewAccount">{{getLanguageStr('word1789','创建新商家')}}</a></li>
			</ul>
		</div>
		<div class="mt05x bdSub boxR-light ofH" v-show="existAccInfo.show" :class="{w60pct:type=='normal'}"  @mouseenter="existAccInfo.mousePos=true"  @mouseleave="existAccInfo.mousePos=false">
			<div class="ml1x mr1x pt05x pb05x taC inputWrap bdSub-bottom">
				<InputText v-model="existAccInfo.searchKey" class="w80pct dpIB bgContent" name="relevanceExistAccount" :placeholder="getLanguageStr('phrase848','请输入商家名称')" :clearBtn="true" ref="searchBox" :searchBtn="true" :fn="getExistList" @AfterClear="afterClear"></InputText>
			</div>
			<div class="posR">
				<Loading v-show="existAccInfo.loading"></Loading>
				<div class="h20x-max lh20 ofH" v-show="existAccInfo.list.length" scroll>
					<ul class="curP_E">
						<li v-for="(item,index) in existAccInfo.list" :key="index" class="hoverBg pl1x pr1x" @click="addExistAccount(item)">
							<div class="pb05x pt05x tableSys vaM_E"
									 :class="{ 'bdSub-bottom':index < existAccInfo.list.length-1}">
								<div>
									<div class="fs12x mt05x">{{item.name}}</div>
								</div>
								<div class="w5x cSub taC">
									<span v-if="item.isAdd">{{getLanguageStr('word56','已选')}}</span>
									<!-- <button type="button" class="fSub" :title="$t('cmd10',['添加'])" v-else> <Icon name="add" class="w1x h1x" :sizeBase="'m'" /> </button> -->
								</div>
							</div>
						</li>
					</ul>
				</div>
				<div class="h12x-min taC tableSys vaM_E"
						 v-show="!existAccInfo.list.length">
					<span class="cSub">{{$t('word1380',['暂无数据'])}}</span>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import * as lib from '@/util/lib.js'
import { getLanguageStr} from '@/util/language.js'
import clickoutside from '@/plugins/clickOutSide/index.js'
import { GetRelBusList } from '@/api/manage/externalRelative.js'

import TagBox from '@/components/common/ui/TagBox.vue'
import InputText from '@/components/common/ui/InputText.vue'
import Loading from '@/components/common/ui/Loading'
import SearchRelative from '@/view/manage/account/SearchRelative.vue'
import AddNewBusiness from '@/view/manage/account/AddNewBusiness.vue'
import EditRelative from '@/view/manage/account/EditRelative.vue'
let timer
export default {
	name: 'relevanceBusiness',
	components: { TagBox, InputText, Loading, SearchRelative, AddNewBusiness, EditRelative },
	directives: { clickoutside },
	mounted () {
		lib.fillHeight()
		lib.setScroll($(this.$el).find('[scroll]'))
		// document.addEventListener('click', this.handleBodyClick)
	},
	watch: {
		'account.acountList' (val) {
			this.$emit('UpdateData', val)
		}
	},
	props: {
		stationId: {
			type: Array
		},
		type: { // 'normal' && 'filter'
			type: String,
			default: 'normal'
		},
		maxAddNum: {// 标签默认最大50
			type: Number,
			default: 50
		},
		list: {// 生效的标签列表
			type: Array,
			default: () => ([])
		}
	},
	data () {
		return {
			showAccount: false,
			showAccountMousePos: false,
			stage,
			existAccInfo: {
				show: false,
				mousePos: false,
				searchKey: '',
				loading: false,
				list: []
			},
			account: {
				acountList: []
			},
			addAccountList: []
		}
	},
	methods: {
		transitionAction: lib.transitionAction,
		getLanguageStr,
		handleClose (e) {
			if (!this.existAccInfo.mousePos && !this.showAccountMousePos) {
				this.showAccount = false
				this.existAccInfo.show = false
			}
		},
		show () {
			this.$nextTick(() => {
				this.account.acountList = _.cloneDeep(this.list)
			})
		},
		showChoose () {
			this.showAccount = true
			this.existAccInfo.show = false
		},
		// mouseLeave () {
		//   setTimeout(()=>{
		//      this.showAccount = false
		//     this.existAccInfo.show = false
		//   },500)
		// },
		_showList () {
			if (this.type === 'filter') {
				this.existAccount()
			} else {
				this.showAccount = true
				this.existAccInfo.show = false
			}
		},
		/// ////////////////////////////选择已有用户///////////////////////
		existAccount () {
			this.existAccInfo.searchKey = ''
			this.existAccInfo.list = []
			this.showAccount = false
			this.existAccInfo.show = true
			this.getExistList()
		},
		// 添加已有账户
		addExistAccount (item) {
			this.addAccountList = []
			this.addAccountList = item
			if (!item.entityRel.roleId && this.type == 'normal') {
				this.$refs.EditRelative.show({...item, type: 1, relative: 'edit'})
			} else {
				if (this.account.acountList.length >= this.maxAddNum && !item.isAdd) {
					this.$notify(i18n.t('fill3rd130', [getLanguageStr('word1650', '商家'), this.maxAddNum, '商家数量已超出上限，上限n个']))
				} else {
					if (!item.isAdd) {
						item.isAdd = !item.isAdd
						this.selectData()
					}
				}
			}
		},
		afterClear () {
			this.existAccount.searchKey = ''
			this.getExistList()
		},
		// 查询存在的商家
		getExistList () {
			let language = stage.languageId
			this.existAccInfo.loading = true
			let requestData = {
				targetEntityName: this.existAccInfo.searchKey,
				// targetEntityType: 1,
				'order.direction': 'ASC',
				'order.property': 'createdDate', // createdTime
				page: 1,
				size: 1000
			}
			GetRelBusList(requestData).then(res => {
				this.existAccInfo.loading = false
				this.existAccInfo.list=res.data;
				if (res.total > 0) {
					let existNameList = res.data.filter(el => el.orgDto.nameList.length)
					existNameList.forEach((val,index)=>{
						if(val.orgDto.nameList.length==1){
							val.name=val.orgDto.nameList[0].name
							
						}else {
							let FilterName=val.orgDto.nameList.filter(el=>el.language===language)
							if(FilterName.length){
								val.name=FilterName[0].name
								
							}else{
								let filterEn=val.orgDto.nameList.filter(el=>el.language==='en')
								if(filterEn.length){
									val.name=filterEn[0].name
									
								}else{
									val.name=val.orgDto.nameList[0].name
								}
							}
						}
					})
					this.existAccInfo.list = existNameList.map(el => ({
						entityRelId: el.entityRel.id,
						name: el.orgDto.org.name,
						isAdd: false,
						orgDto: el.orgDto, // 编辑关系是用到这样结构取name
						entityRel: el.entityRel // 添加商家时判断里面roleid是否存在
					}))
				}
				if (this.account.acountList.length > 0) {
					this.existAccInfo.list.forEach((el, index) => {
						this.account.acountList.forEach(attr => {
							if (el.entityRelId === attr.entityRelId) {
								el.isAdd = true
							}
						})
					})
				}
			}, error => {
				this.existAccInfo.loading = false
				!_.isEmpty(error) && this.$notify(error)
			})
		},
		selectData () {
			this.account.acountList = this.existAccInfo.list.filter(el => el.isAdd)
			this.$emit('Update', this.account.acountList)
		},
		clear () {
			this.account.acountList = []
			this.existAccInfo.list.forEach(el => {
				this.$set(el, 'isAdd', false)
			})
			this.selectData()
		},
		onRemove (id, index) {
			// this.account.acountList.splice(index,1)
			this.existAccInfo.list.forEach((el, index) => {
				if (el.entityRelId === id) {
					this.existAccInfo.list[index].isAdd = false
				}
			})
			this.selectData()
		},
		/// ////////////////////添加商家////////////////////////////////
		addAccount (type) {
			this.showAccount = false
			this.$refs.SearchRelative.show(type)
		},
		AddAccountChoose (item) {
			let isExist = this.account.acountList.filter(el => el.entityRelId == item.entityRelId)
			if (!isExist.length) {
				this.account.acountList.push({
					entityRelId: item.entityRelId,
					name: item.name
				})
			}
		},
		AddRelative (data) {
			this.addAccountList = []
			this.addAccountList = data
			data.orgDto = {}
			data.orgDto.org = data.org // 传入的name与外部关系用户列表传入的位置一置data.orgDto.org.name
			if (data.entityRel) { // entityRel:{ roleId:''} 这种情况下需要编辑外部关系
				this.$refs.EditRelative.show({...data, type: 1, relative: 'edit'})
			} else {
				this.$refs.EditRelative.show({...data, type: 1, relative: 'add'})
			}
		},
		updateData (id) {
			this.account.acountList.push({
				name: this.addAccountList.name,
				entityRelId: id,
				isAdd: true
			})
		},
		/// /////////////////////////创建新商户/////////////////////////////
		buildNewAccount () {
			if (this.showAccount) {
				this.showAccount = false
			}
			this.$dynamic(this.$el, AddNewBusiness, {}, {
				updateList: [this.afterBuild.bind(this)]
				// Close:[this.closeViewSys.bind(this)],
				// refresh:[this.refresh.bind(this)],
				// update:[this.getExistList.bind(this)],
				// Follow:[this.Follow.bind(this)]
			}).then(dynamic => {
				dynamic.childInstance.show()
			})
		},
		afterBuild (data, id) {
			this.account.acountList.push({
				name: data.nameList[0].name,
				entityRelId: id,
				isAdd: true
			})
		}
	}

}
</script>

<style lang="scss" scoped>
.chooseList {
	> * {
		line-height: 2.5em;
		cursor: pointer;
	}
	> li:last-child {
		border-bottom: none;
	}
}
.bd-last > *:last-child {
	border-bottom: none;
}
.dvStatus {
	width: 1.2em;
	height: 1.2em;
}
.enableList {
	padding: {
		bottom: 0.5em;
	}
	position: relative;
	.clearTag {
		position: absolute;
		top: 0;
		right: 0.5em;
	}
}
</style>



// WEBPACK FOOTER //
// src/view/maintain/light/plant/relevance/RelevanceBusiness.vue